import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      d="M12,2 L2,2 L2,13 L6,13 L6,14 L1,14 L1,13 L1,2 L1,1 L13,1 L13,2 L13,6 L12,6 L12,2 Z M5,5 L10.999,5 L10.999,4 L5,4 L5,5 Z M3,5 L3,4 L4,4 L4,5 L3,5 Z M5,8 L5,7 L11,7 L11,8 L5,8 Z M3,8 L3,7 L4,7 L4,8 L3,8 Z M5,11 L5,10 L8,10 L8,11 L5,11 Z M3,11 L3,10 L4,10 L4,11 L3,11 Z M7.502,12.41 L12.913,7 L15,9.087 L9.59,14.497 L7,15 L7.502,12.41 Z"/>
  </svg>
);
